import { render, staticRenderFns } from "./ordersExecutors.vue?vue&type=template&id=6c8d3ce7&"
import script from "./ordersExecutors.vue?vue&type=script&lang=js&"
export * from "./ordersExecutors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports